import { useCallback } from 'react'

const useBackButton = ({
  selectedCategories,
  onBackNavigation,
  onShowBackModal
}) => {
  const handleBack = useCallback(() => {
    if (selectedCategories && selectedCategories.length > 0) {
      onBackNavigation()
    } else {
      onShowBackModal(true)
    }
  }, [selectedCategories, onBackNavigation, onShowBackModal])

  return { handleBack }
}

export default useBackButton
